import { useState } from 'react'

import { CookieConsentForm } from '@mondough/consent-management/ui'
import { Copy, useCopy } from '@mondough/copy'
import { Text, Title } from '@mondough/monzo-ui'

import { PlainLayout } from '../../components'
import styles from './index.module.scss'

export default function CookiesPage() {
  const [prefsUpdated, setPrefsUpdated] = useState(false)
  const c = useCopy()

  return (
    <PlainLayout
      pageTitle={c.string({
        key: 'app_tabs_monzo_me.cookies.page.title',
        message: 'Monzo Split: Cookie Notice',
      })}
      className={styles.container}
    >
      <Text marginBottom="small">
        <Copy.Simple
          id="app_tabs_monzo_me.cookies.card.intro"
          fallback="Cookies help us give you a better Monzo Split experience.\n\nThink of cookies as stickers - every time you visit a site, a sticker is put on you to tally the number of times you've visited, how long you've spent there, and what you've done.\n\nThat lets the site show things relevant to you, based on information you've entered and stuff you've looked at. The length of time stored depends on the cookie, but this is generally between a few minutes and up to two years."
        />
      </Text>

      <Title is="h2">
        <Copy.Simple
          id="app_tabs_monzo_me.cookies.card.settings.title"
          fallback="Cookie settings"
        />
      </Title>
      <CookieConsentForm
        className={styles.form}
        onSubmit={() => setPrefsUpdated(true)}
      />
      {prefsUpdated && (
        <Text bold color="mid-teal">
          <Copy.Simple
            id="app_tabs_monzo_me.cookies.card.settings.form.success"
            fallback="Your preferences have been updated."
          />
        </Text>
      )}

      <Title is="h2" marginBottom="small">
        <Copy.Simple
          id="app_tabs_monzo_me.cookies.card.other.title"
          fallback="Other ways to turn off cookies"
        />
      </Title>
      <Text marginBottom="small">
        <Copy.Simple
          id="app_tabs_monzo_me.cookies.card.other.description"
          fallback="You can also turn all cookies off in your browser or phone settings.\n\nIf you want to do this, try looking in your internet browser's help menu, or searching for 'how to block cookies'. Your browser also lets you delete any cookies stored on your device, whenever you wish."
        />
      </Text>

      <Title is="h2">
        <Copy.Simple
          id="app_tabs_monzo_me.cookies.card.questions.title"
          fallback="Questions?"
        />
      </Title>
      <Text marginTop="extra-small">
        <Copy.Simple
          id="app_tabs_monzo_me.cookies.card.questions.description"
          fallback="We take privacy very seriously and are always open to your feedback. If you have any more questions about our cookie notice or how we use cookies please email "
        />
        <a className={styles.link} href="mailto:help@monzo.com">
          help@monzo.com
        </a>
        .
      </Text>
    </PlainLayout>
  )
}

CookiesPage.analytics = { name: 'cookie-notice' }
